"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var FormRow_1 = __importDefault(require("./FormRow"));
var FormField_1 = __importDefault(require("./FormField"));
var FormSubmitButton_1 = __importDefault(require("./FormSubmitButton"));
var FormCancelButton_1 = __importDefault(require("./FormCancelButton"));
var Container_1 = __importDefault(require("react-bootstrap/Container"));
var Row_1 = __importDefault(require("react-bootstrap/Row"));
var Col_1 = __importDefault(require("react-bootstrap/Col"));
var FieldMapForm = function (props) {
    var fieldMap = props.fieldMap, readOnly = props.readOnly, onBlur = props.onBlur, onChange = props.onChange, onSubmit = props.onSubmit, onReset = props.onReset, loading = props.loading;
    var createFormField = function (formField) {
        var options = !formField.formOptions
            ? undefined
            : formField.formOptions.map(function (formOption) {
                return [formOption.value, formOption.label];
            });
        return (react_1.default.createElement(FormField_1.default, { fieldName: formField.fieldName, fieldNameId: formField.fieldNameId, showLabel: formField.parentFieldNameId ? true : false, layout: formField.parentFieldNameId ? 'horizontal' : undefined, controlType: formField.controlType, constraint: formField.constraint, options: options, readOnly: readOnly || loading || formField.readOnly, errorId: formField.errorId, invalid: formField.invalid, value: formField.value, onBlur: onBlur, onChange: onChange }));
    };
    var renderFormFieldObjects = function (objects) {
        return (react_1.default.createElement(Container_1.default, { fluid: true },
            react_1.default.createElement(Row_1.default, null, objects.map(function (object, index) {
                return react_1.default.createElement(Col_1.default, { key: index }, object);
            }))));
    };
    var rows = function () {
        var fieldGroups = {};
        Object.keys(fieldMap).forEach(function (key, index) {
            var formField = fieldMap[key];
            var fieldGroupId = formField.parentFieldName
                ? formField.parentFieldName
                : formField.fieldName;
            if (!fieldGroups[fieldGroupId]) {
                fieldGroups[fieldGroupId] = [];
            }
            fieldGroups[fieldGroupId].push(formField);
        });
        // sort by displayOrder
        var sortedFieldGroups = {};
        Object.keys(fieldGroups).forEach(function (key, index) {
            var value = fieldGroups[key];
            var keyIndex = value.length == 1 ? value[0]['order'] : value[0]['parentOrder'];
            sortedFieldGroups[keyIndex] = value;
        });
        return Object.keys(sortedFieldGroups).map(function (key, index) {
            var formFieldGroup = sortedFieldGroups[key];
            var formFieldObjects = formFieldGroup.map(function (formField) {
                return createFormField(formField);
            });
            var firstFormField = formFieldGroup[0];
            var rowNameId = formFieldGroup.length == 1 ? firstFormField.fieldNameId : firstFormField.parentFieldNameId;
            var layout = firstFormField.layout;
            if (layout === 'horizontal') {
                //   return (
                //     <FormRowHorizontal key={formField.fieldNameId} rowNameId={formField.fieldNameId} required={formField.required}>
                //       {formFieldObject}
                //     </FormRowHorizontal>
                //   )
            }
            return (react_1.default.createElement(FormRow_1.default, { key: key, rowNameId: rowNameId, required: firstFormField.required, layout: layout }, renderFormFieldObjects(formFieldObjects)));
        });
    };
    return (react_1.default.createElement(Container_1.default, { fluid: true, className: "aw-form mb-5" },
        rows(),
        react_1.default.createElement(FormRow_1.default, null,
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, { className: "d-flex justify-content-center pt-4 pb-4" },
                    react_1.default.createElement(FormSubmitButton_1.default, { onClick: onSubmit, loading: loading }))),
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, { className: "d-flex justify-content-center pt-4 pb-4" },
                    react_1.default.createElement(FormCancelButton_1.default, { onClick: onReset, loading: loading }))))));
};
FieldMapForm.propTypes = {
    fieldMap: prop_types_1.default.any,
    onBlur: prop_types_1.default.func,
    onChange: prop_types_1.default.func,
    onSubmit: prop_types_1.default.func,
    onReset: prop_types_1.default.func,
};
exports.default = FieldMapForm;
//# sourceMappingURL=FieldMapForm.js.map